import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import cn from 'classnames';
import { Checkbox, MenuItem, Select, Typography, useDevice, WithInfoIcon } from 'seagull';
import { getAllAutoApprovalDays, getAutoApprovalRange, isAutoApprovalValid } from '~/business-logic/autoApprovalLogic';
import { useLocaleKeys } from '~/i18n';
import pluralize from '~/utils/pluralize';
import styles from './ApprovalMethodNoticePeriodField.module.scss';
export function validateApprovalMethodNoticePeriod(enabled, noticePeriod) {
    return !enabled || !!noticePeriod && isAutoApprovalValid(noticePeriod);
}
export const ApprovalMethodNoticePeriodField = (props)=>{
    const { t: texts } = useLocaleKeys('components.approvalMethodNoticePeriod');
    const { info, text, testId, enabled, noticePeriod, isReadOnly, onToggle, onChangePeriod } = props;
    const { minDays, maxDays } = getAutoApprovalRange();
    const { isMobileDevice } = useDevice();
    const dayOptions = useMemo(()=>getAllAutoApprovalDays().map((value)=>({
                value,
                text: pluralize('day', value, true),
                testId: "".concat(testId, "-period-").concat(value)
            })), []);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx(WithInfoIcon, {
                    info: info,
                    children: /*#__PURE__*/ _jsx(Checkbox, {
                        checked: enabled,
                        disabled: isReadOnly,
                        onChange: (e)=>onToggle(e.currentTarget.checked),
                        testId: "".concat(testId, "-toggle"),
                        children: /*#__PURE__*/ _jsx(Typography, {
                            children: text
                        })
                    })
                })
            }),
            enabled && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: cn(styles.periodInput, {
                            [styles.mobile]: isMobileDevice
                        }),
                        children: /*#__PURE__*/ _jsx(Select, {
                            collapseHelperText: false,
                            mobile: {
                                renderAsCard: true
                            },
                            label: texts.noticePeriodLabel(),
                            value: noticePeriod,
                            disabled: isReadOnly,
                            isSelected: (itemValue, currentValue)=>+itemValue === +currentValue,
                            menuMaxHeight: 220,
                            testId: "".concat(testId, "-period"),
                            onChange: (e)=>onChangePeriod(Number.parseInt(e.target.value)),
                            children: dayOptions.map((param)=>{
                                let { value, text, testId } = param;
                                return /*#__PURE__*/ _jsx(MenuItem, {
                                    value: '' + value,
                                    testId: testId,
                                    children: text
                                }, value);
                            })
                        })
                    }),
                    !validateApprovalMethodNoticePeriod(enabled, noticePeriod) && /*#__PURE__*/ _jsxs(Typography, {
                        skin: "error",
                        variant: "paragraph2",
                        testId: "".concat(testId, "-error"),
                        children: [
                            "Notice period must be between ",
                            minDays,
                            " and ",
                            maxDays,
                            " days"
                        ]
                    })
                ]
            })
        ]
    });
};
